import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import ThemeProvider from '@mui/material/styles/ThemeProvider';
import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';

// routing
import Routes from './routes';

// defaultTheme
import theme from './themes';

// project imports
import NavigationScroll from './layout/NavigationScroll';
import { Typography } from '@mui/material';

import AuthInit from './utils/auth/AuthInit';

//? Para pegar o User
import { useDispatch } from 'react-redux';
import api from './views/services/api';
import { ACCOUNT_INITIALIZE } from './store/actions';
import { fetchMe } from './utils/auth/auth';
import { registerLogout } from '../src/utils/auth/LogoutHelper';

//adicionado
import { ThemeProvider as MuiStylesThemeProvider } from '@mui/styles';

// import { fetchConversationIds, fetchMessages, fetchNameUser, postMessage, getAvatarUrl } from './api';

//-----------------------|| APP ||-----------------------//

const App = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        if (!token) return;

        // garante header após refresh
        api.defaults.headers.common.Authorization = `Bearer ${token}`;

        const init = async () => {
            try {
                const res = await fetchMe();

                dispatch({
                    type: ACCOUNT_INITIALIZE,
                    payload: {
                        isLoggedIn: true,
                        user: res.data,
                        token
                    }
                });
            } catch (err) {
                console.warn('Token inválido, deslogando');

                localStorage.removeItem('access_token');
                localStorage.removeItem('refresh_token');

                dispatch({
                    type: ACCOUNT_INITIALIZE,
                    payload: {
                        isLoggedIn: false,
                        user: null,
                        token: null
                    }
                });
            }
        };

        init();
    }, [dispatch]);

    console.log(`entrou em App`);
    const customization = useSelector((state) => state.customization);
    // console.log(`customization:`, customization);

    const safeCustomization = customization || {
        mode: 'light',
        borderRadius: 12,
        fontFamily: "'Roboto', sans-serif"
    };

    // const safeCustomization = {
    //     ...customization,
    //     mode: 'dark'
    // };

    const themeInstance = useMemo(() => theme(safeCustomization), [safeCustomization]);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themeInstance}>
                <MuiStylesThemeProvider theme={themeInstance}>
                    <CssBaseline />
                    <NavigationScroll>
                        <AuthInit>
                            <Routes />
                        </AuthInit>
                    </NavigationScroll>
                </MuiStylesThemeProvider>
            </ThemeProvider>
        </StyledEngineProvider>
        // <StyledEngineProvider injectFirst>
        // <ThemeProvider theme={theme(customization)}> // FUNCIONA
        // <ThemeProvider theme={themeInstance}> {/* NOVO */}
        // <MuiStylesThemeProvider theme={themeInstance}> {/* NOVO */}
        // <CssBaseline />
        // <NavigationScroll>
        // <AuthInit>
        // <Routes />
        // </AuthInit>
        // </NavigationScroll>
        // </MuiStylesThemeProvider>
        // </ThemeProvider>
        // </StyledEngineProvider>
    );
};

export default App;
